// extracted by mini-css-extract-plugin
module.exports = {"bulletActiveClass":"carousel-custom-styles_bulletActiveClass__rcZFs","bulletClass":"carousel-custom-styles_bulletClass__7jxSm"};